import { DropDownList } from '@progress/kendo-react-dropdowns';
import * as React from 'react'
import { Col, Label, Row } from 'reactstrap'
import './styles.css'

interface ComponentProps {
  dataArray: string[],
  handleChange: any,
  label: string,
  value: string,
}

export const LeadTextDropdown = ({ dataArray, label, handleChange, value }: ComponentProps) => <Row>
  <Col md="6"><Label className="editor-label">{label}</Label></Col>
  <Col md="4" className="dropdown-width">
    <DropDownList data={dataArray}
                  value={value}
                  onChange={handleChange} />
  </Col>
</Row>



// WEBPACK FOOTER //
// ./src/pages/lead-text/custom-toolbar-options/lead-text-dropdown.tsx